import React from 'react';
import LaunchOutlinedIcon from '@mui/icons-material/LaunchOutlined';
import './style.scss';
import { TextButton, Tooltip } from '@shape-ds/components';
import { useNavigate } from 'react-router-dom';

interface ExternalLinkProps {
  url: string;
  label?: string;
  isExternalLink?: boolean;
  className?: string;
  iconPosition?: 'end' | 'start';
  themeColor?: 'blue' | 'white';
  tooltipText?: string;
}

const ButtonLink: React.FC<ExternalLinkProps> = ({
  url,
  label,
  isExternalLink = true,
  className,
  iconPosition = 'start',
  themeColor = 'blue',
  tooltipText,
}) => {
  const navigate = useNavigate();
  const onClick = () => (isExternalLink ? window.open(url, '_blank') : navigate(url));

  return (
    <TextButton
      startIcon={iconPosition === 'start' ? <LaunchOutlinedIcon /> : undefined}
      endIcon={iconPosition === 'end' ? <LaunchOutlinedIcon /> : undefined}
      className={`external-link ${themeColor} ${!label ? 'no-label' : ''} ${className}`}
      onClick={onClick}
    >
      {tooltipText ? (
        <Tooltip title={tooltipText} followCursor={false} placement="top">
          {label}
        </Tooltip>
      ) : (
        label
      )}
    </TextButton>
  );
};

export default ButtonLink;
